@if (selectedFiles.length) {
  <app-file-progress-bar-status/>
} @else {
  <div
    class="upload-dropzone"
    [class]="getClasses()"
    (drop)="handleFileDropped($event)"
    (dragover)="handleDragOver($event)"
    (dragleave)="handleDragLeave($event)"
  >
    <p>Перетащите файлы</p>
    <div class="upload-buttons">
      <button
        mat-icon-button
        tabindex="-1"
        class="button-icon"
        [class.button-icon-active]="pasteEnabledStateService.isPasteEnabled(fileUploadParams().type)"
        [matTooltip]="getTooltip()"
        (click)="togglePasteMode()"
      >
        <mat-icon>
          {{ getIcon() }}
        </mat-icon>
      </button>
      <button
        mat-icon-button
        tabindex="-1"
        class="button-icon"
        (click)="fileInput.click()"
      >
        <mat-icon>attach_file</mat-icon>
      </button>
    </div>
    <input
      type="file"
      #fileInput
      hidden
      [multiple]="isMultiple()"
      (change)="handleFileSelected($event)"
    />
  </div>
}
